import React from 'react'

const Footer = () => {
  return (
    <div className='div-footer'>
        <p>@copyright 2026 - ResumeFit AI</p>
    </div>
  )
}

export default Footer